"use client";

import Reveal from "@/components/Reveal";
import { useTranslations } from "@/i18n/LocaleProvider";
import { whatsappNumber } from "@/lib/site";

const PREFILLED_MESSAGE = "Hi! I'd like to join the WhatsApp community.";

// Same full-width gradient-card treatment as CorporateCollabCard, in WhatsApp's own green
// instead of the brand indigo, so the two callouts read as a matched pair rather than
// competing styles. Opens the same WhatsApp Business chat the floating button uses (see
// WhatsAppButton.tsx) -- there's no separate community broadcast-list invite link configured
// yet, so this starts a real 1:1 chat rather than linking somewhere fake.
export default function WhatsAppCommunityCard() {
  const { t } = useTranslations();
  const href = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(PREFILLED_MESSAGE)}`;
  return (
    <Reveal className="relative isolate overflow-hidden px-8 py-10 sm:px-16 sm:py-16 text-center text-white">
      <div
        className="absolute inset-0 -z-10"
        style={{
          background:
            "radial-gradient(120% 140% at 15% 15%, #25D366 0%, #0d2b1a 55%), radial-gradient(100% 120% at 100% 100%, #128C7E 0%, transparent 55%)",
        }}
      />
      <div className="mx-auto max-w-lg">
        <h2 className="font-display text-3xl sm:text-4xl">{t("home.whatsappCommunity.title")}</h2>
        <p className="mt-4 text-white/75">{t("home.whatsappCommunity.body")}</p>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-8 inline-flex items-center gap-2 rounded-xl bg-white px-7 py-3 font-semibold text-[#0d2b1a] transition hover:opacity-90"
        >
          <svg viewBox="0 0 32 32" className="size-4" fill="currentColor" aria-hidden>
            <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.258.594 4.472 1.72 6.416L3.2 28.8l6.56-1.68a12.74 12.74 0 0 0 6.244 1.68h.006c7.06 0 12.8-5.74 12.8-12.8s-5.74-12.8-12.806-12.8Zm0 23.36h-.005a10.53 10.53 0 0 1-5.37-1.47l-.385-.229-3.892.997.999-3.79-.251-.39a10.552 10.552 0 0 1-1.618-5.678c0-5.834 4.75-10.583 10.588-10.583 2.828 0 5.486 1.102 7.485 3.103a10.516 10.516 0 0 1 3.098 7.486c0 5.834-4.75 10.554-10.65 10.554Zm5.79-7.906c-.317-.159-1.877-.927-2.168-1.033-.29-.106-.502-.159-.713.16-.212.317-.82 1.032-1.005 1.244-.185.212-.37.238-.687.08-.317-.16-1.338-.494-2.549-1.575-.942-.84-1.578-1.878-1.763-2.195-.185-.318-.02-.49.139-.648.143-.142.317-.37.476-.556.16-.185.212-.318.318-.53.106-.212.053-.397-.026-.556-.08-.159-.713-1.72-.977-2.354-.257-.617-.518-.534-.713-.544l-.607-.011a1.166 1.166 0 0 0-.846.397c-.291.318-1.11 1.086-1.11 2.647s1.137 3.07 1.296 3.282c.16.212 2.24 3.42 5.428 4.795.758.328 1.35.523 1.812.669.762.242 1.455.208 2.003.126.611-.091 1.877-.767 2.141-1.508.265-.741.265-1.376.185-1.508-.08-.132-.291-.212-.608-.37Z" />
          </svg>
          {t("home.whatsappCommunity.cta")}
        </a>
      </div>
    </Reveal>
  );
}
